import { createFileRoute } from '@tanstack/react-router'
import { RouteErrorFallback } from '@/components/ErrorBoundary'
import { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PageContainer, PageCard, PageHeader, PageHeaderContent, PageHeaderTitle, PageHeaderHeading, PageHeaderDescription, PageContent } from '@/components/ui/page'
import { ApiKeyList } from '@/components/api-keys/ApiKeyList'
import { NotificationSettings } from '@/components/settings/NotificationSettings'

export const Route = createFileRoute('/settings')({
  component: Settings,
  errorComponent: RouteErrorFallback,
})

function Settings() {
  const [activeTab, setActiveTab] = useState('general')

  return (
    <PageContainer>
      <PageCard>
        <PageHeader>
          <PageHeaderContent>
            <PageHeaderTitle>
              <PageHeaderHeading>Einstellungen</PageHeaderHeading>
              <PageHeaderDescription>Verwalten Sie Ihre Systemeinstellungen und API-Schlüssel</PageHeaderDescription>
            </PageHeaderTitle>
          </PageHeaderContent>
        </PageHeader>

        <PageContent className="p-6 overflow-auto">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            {/* Unter sm untereinander: „Benachrichtigungen" braucht mehr Breite als
                eine Drittelspalte auf dem Handy hergibt. Ab sm wie bisher dreispaltig. */}
            <TabsList className="grid w-full grid-cols-1 h-auto max-w-[600px] sm:grid-cols-3 sm:h-9">
              <TabsTrigger value="general">Allgemein</TabsTrigger>
              <TabsTrigger value="notifications">Benachrichtigungen</TabsTrigger>
              <TabsTrigger value="api-keys">API-Schlüssel</TabsTrigger>
            </TabsList>

            <TabsContent value="general" className="mt-6">
              <Card>
                <CardHeader>
                  <CardTitle>Allgemeine Einstellungen</CardTitle>
                  <CardDescription>Verwalten Sie Ihre App-Einstellungen</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <h3 className="text-sm font-medium mb-2">Sprache</h3>
                    <p className="text-sm text-muted-foreground">Deutsch (Deutschland)</p>
                  </div>
                  <Separator />
                  <div>
                    <h3 className="text-sm font-medium mb-2">Theme</h3>
                    <p className="text-sm text-muted-foreground">System</p>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            <TabsContent value="notifications" className="mt-6">
              <NotificationSettings />
            </TabsContent>

            <TabsContent value="api-keys" className="mt-6">
              <ApiKeyList />
            </TabsContent>
          </Tabs>
        </PageContent>
      </PageCard>
    </PageContainer>
  )
}